import { Link } from 'react-router-dom';
import { IDadosDisciplina } from '@/@types/Academico/Disciplina';

import { TableCell, TableRow } from '@/components/ui/table';
import { Button } from '@/components/shared/Button';

interface IRowTableWithButtonPrograma {
    data: IDadosDisciplina; // Dados da disciplina
}

/**
 * Linha de tabela para exibir dados de disciplina com um botão para acessar o programa da disciplina.
 * @param data Dados da disciplina.
 * @returns Componente de linha de tabela com botão para programa.
 */

const RowTableWithButtonPrograma = ({ data }: IRowTableWithButtonPrograma) => {

    return (
        <TableRow className='has-[td]:p-[10px] has-[td]:font-normal'>
            <TableCell>
                <strong>{data.ANO_CATAL}</strong>
                <br />
                {data.TIPO_CARAC_DISC}
                <br />
                <strong>{data.TIPO_OFER_DISC % 2 == 0 ? '2' : '1'} Semestre</strong>
            </TableCell>

            <TableCell>
                <strong>{data.COD_DISCI}</strong>
                <br />
                {data.NOME_DISCI}
                {data.NOME_DOCENTE && (
                    <>
                        <br />
                        {data.NOME_DOCENTE}
                    </>
                )}
            </TableCell>

            <TableCell>
                {data.NUM_CRED_DISCI}
                <br />
                {data.CARGA_HORARIA}H
                <br />
                <strong>{data.TIPO_OFER_DISC} Período</strong>
            </TableCell>

            <TableCell>
                <Link target='_blank' to={`/extranet/academico/${data.COD_DISCI.slice(0, 2) == 'AP' ? 'pos-graduacao' : 'graduacao'}/disciplinas/programa/${data.ANO_CATAL}/${data.COD_DISCI}`}>
                    <Button className='flex-col p-4' variant='secondary' >
                        <i className='fas fa-search'></i>
                        Programa
                    </Button>
                </Link>
            </TableCell>
        </TableRow>
    );

}

export { RowTableWithButtonPrograma };